import { useCallback } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/factor-sensitivity-contributors"
import "./style.scss"
import { THRESHOLD_PARAMS } from "helpers/threshold"

function AnalyzeFactorSensitivityDetails({
  selectedDate,
  selected,
  selectedValue,
  details,
  viewType,
  displayTypeName,
  order,
  show,
  hide,
  sort,
  openFactorProfile,
  openSecurityProfile,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  groupSort,
  groupOrder,
  toggleShowNotHeld,
  selectedViews,
  factorSensitivityType,
  thresholdParams,
}) {
  const makeTrackedAction = useCallback((fn) => (...args) => {
    fn(...args, factorSensitivityType)
  }, [factorSensitivityType])

  return <div className={classnames("modules_analyze-factor-sensitivity-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    {!selected
      ? <DailyDetails {...{
          viewType,
          openFactorProfile,
          displayTypeName,
          data: details,
          factorTable: true,
          show: makeTrackedAction(show),
          groupSort: makeTrackedAction(groupSort),
          groupOrder,
          thresholdParams,
        }}
      />
      : <ContributorsDetails {...{
          viewType,
          openSecurityProfile,
          openFactorProfile,
          showGroup: makeTrackedAction(showGroup),
          hideGroup,
          selectedGroup,
          hide,
          sort: makeTrackedAction(sort),
          order,
          selected,
          selectedValue,
          selectedDate,
          setContributorsGrouping: makeTrackedAction(setContributorsGrouping),
          contributorsGrouping,
          selectedOption,
          toggleShowNotHeld,
          details,
          show: makeTrackedAction(show),
          groupOrder,
          selectedViews,
          factorSensitivityType,
        }}
      />}
  </div>
}

AnalyzeFactorSensitivityDetails.propTypes = {
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  order: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  sort: PropTypes.func,
  openFactorProfile: PropTypes.func,
  openSecurityProfile: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object,
  displayTypeName: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  factorSensitivityType: PropTypes.string.isRequired,
  thresholdParams: THRESHOLD_PARAMS,
}

export default AnalyzeFactorSensitivityDetails
